import logo from '@root/img/logo.png';
import './style.scss';

const Logo = () => {
  const isGoodpay = window.location.href.includes('goodpay');

  return (
    <>
      {isGoodpay ? (
        <span className="img-box">
          <svg
            width="180"
            height="45"
            viewBox="0 0 120 28"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="7" r="5" fill="#4354CD" fillOpacity="1.0" />
            <circle cx="18" cy="13" r="5" fill="#4354CD" fillOpacity="0.8" />
            <circle cx="24" cy="19" r="5" fill="#4354CD" fillOpacity="0.6" />
            <text
              x="40"
              y="21"
              fill="#FFFFFF"
              fontFamily="Arial"
              fontSize="14px"
              fontWeight="bold"
            >
              GoodPay
            </text>
          </svg>
        </span>
      ) : (
        <span className="img-box">
          <img
            src={logo}
            alt="Logo"
            style={{ width: '100%' }}
            className="img-item"
          />
        </span>
      )}
    </>
  );
};

export default Logo;
